/* v10-product.js — la ficha v10 (sesión D, 25 oct 2026; rehecha en el lote
   pdp-window, v11, 31 oct 2026). Sin dependencias.

   LEE, NO DECIDE. El estado, la etiqueta, el botón, la línea de plazo y el
   texto de cada respuesta los escribe el servidor
   (`sections/v10-product.liquid`, desde `snippets/v10-state.liquid` y
   `snippets/fit-check.liquid`). Aquí solo se busca la variante que casa con
   las opciones elegidas y se copia su registro a la página.

   Qué hace:
     · Opciones: elegir un color o una talla busca la variante y aplica su
       registro (precio, botón, propiedades `_state` / `Ships in`, la línea
       de plazo, el aviso solo en `notify`, la entrega solo en stock, marcas
       `PRE`, asunto del correo, la foto de la variante y `?variant=`).
     · Añadir sin recargar: el formulario va a `acaciasupplies.siteDrawer.add`
       (`assets/site-drawer.js`, lote home-pulido S5): una sola petición a
       /cart/add.js que trae el drawer Bag y el número del header, y abre
       ese drawer; `bag_add` por `v10:track`. Un fallo emite
       `v10:cart-error`, sale en la consola y lo dice bajo el botón.
     · `notify`: el botón apagado y el aviso en un `<details>` cuyo resumen
       es el botón secundario. `#v10-notify` en la URL lo abre.
     · El visor (≥ 990 px): una foto a la vez; las miniaturas la cambian al
       instante (clic, Enter, flechas, Home/End; `aria-current`), con el
       `alt`, el contador y el «+» de la foto que se ve. En móvil, el
       carrusel se desliza y el contador y los puntos lo siguen.
     · El panel «Inside the piece»: la fila de la columna lo abre en el sitio
       del visor (escritorio) o como hoja a pantalla completa con el scroll
       de detrás bloqueado (móvil). «× Photos» / «× Close» y `Esc` lo
       cierran y el foco vuelve a la fila. Sin animación (regla 6). El
       estado no se guarda: al cargar, siempre el visor.
     · La columna (≥ 990 px) va con la página, sin scroll propio (v12, A1):
       aquí solo se elige su modo `sticky` con una clase, `is-fit` si cabe
       en `100svh − header` (se fija bajo el header) o `is-tall` si no
       (se fija por abajo). Al cargar, al redimensionar y cada vez que la
       columna cambia de alto (`ResizeObserver`: filas, panel, aviso). Sin
       JS no hay clase y la columna es estática.
     · «What fits»: cada chip escribe su respuesta (`data-text`), uno
       pulsado por pregunta, sin recargar.
     · La entrega (`snippets/delivery-line`): la misma cuenta que el
       servidor, otra vez aquí con la hora del navegador, porque la página
       puede llegar de la caché después del corte (`as.delivery`, para el
       QA). Desde el lote pdp-reassurance, en minutos, rehecha una vez por
       minuto y al volver de oculto, y con la zona de «Deliver to».
     · Medición: `product_view`, `swatch_change`, `ask_click`, `specs_open`,
       `fits_view`, `notify_join` (por `v10:track`, que publica
       `assets/v10-analytics.js`). */
(function (w, d) {
  'use strict';
  var as = w.acaciasupplies = w.acaciasupplies || {};
  if (as.v10pdp) return;
  var page = d.querySelector('[data-v10-pdp]');
  if (!page) return;
  as.v10pdp = true;

  var data;
  try {
    data = JSON.parse(page.querySelector('[data-v10-product]').textContent);
  } catch (err) {
    console.error('v10-product: the product data could not be read', err);
    return;
  }

  var $ = function (s, r) { return (r || page).querySelector(s); };
  var $$ = function (s, r) { return Array.prototype.slice.call((r || page).querySelectorAll(s)); };
  var root = (w.Shopify && w.Shopify.routes && w.Shopify.routes.root) || '/';
  var desk = w.matchMedia ? w.matchMedia('(min-width: 990px)') : { matches: true, addEventListener: function () {} };

  var variants = data.variants || [];
  var form = d.getElementById('v10-buy-form');
  var idInput = $('[data-v10-id]');
  var current = variants.filter(function (v) { return idInput && String(v.id) === idInput.value; })[0] || variants[0];
  if (!current) return;
  as.v10product = { id: data.id, handle: data.handle, variantId: current.id, state: current.state };

  function track(name, payload) {
    var p = payload || {};
    if (!p.product_id) p.product_id = data.id;
    if (!p.state) p.state = current.state;
    d.dispatchEvent(new CustomEvent('v10:track', { detail: { name: name, payload: p } }));
  }
  function pad(n) { return (n < 10 ? '0' : '') + n; }

  /* ── Opciones ─────────────────────────────────────────────────────────── */
  var fields = $$('[data-v10-opt]');
  /* Las opciones elegidas, por su ÍNDICE de opción: las que no tienen
     selector (un solo valor) se quedan con el de la variante actual. */
  function chosen() {
    var values = current.options.slice();
    fields.forEach(function (f) {
      var c = f.querySelector('input:checked');
      values[+f.getAttribute('data-v10-opt')] = c ? c.value : null;
    });
    return values;
  }
  function exact(values) {
    return variants.filter(function (v) {
      return v.options.every(function (o, i) { return values[i] == null || o === values[i]; });
    })[0] || null;
  }
  /* La variante de un valor con las demás opciones elegidas; si no existe,
     la primera que lleva ese valor. La misma regla que pinta el servidor. */
  function bestFor(oi, value, values) {
    var trial = values.slice();
    trial[oi] = value;
    return exact(trial) || variants.filter(function (v) { return v.options[oi] === value; })[0] || null;
  }
  function labelOf(input) {
    return input.id ? page.querySelector('label[for="' + input.id + '"]') : null;
  }
  function marks(values) {
    fields.forEach(function (f) {
      var oi = +f.getAttribute('data-v10-opt');
      $$('[data-v10-opt-input]', f).forEach(function (input) {
        var v = bestFor(oi, input.value, values);
        var label = labelOf(input);
        if (!label) return;
        var mark = label.querySelector('[data-v10-mark]');
        if (mark) mark.hidden = !(v && v.state === 'preorder');
        label.classList.toggle('is-out', !v || v.state === 'notify');
      });
    });
  }
  function legend(f, text) {
    var el = f.querySelector('[data-v10-opt-value]');
    if (el) el.textContent = text;
  }

  /* ── Aplicar el registro de una variante ──────────────────────────────── */
  var el = {
    price: $('[data-v10-price]'),
    cta: $('[data-v10-cta]'),
    propState: $('[data-v10-prop-state]'),
    propWeeks: $('[data-v10-prop-weeks]'),
    line: $('[data-v10-line]'),
    notify: $('[data-v10-notify]'),
    soon: $('[data-v10-soon]'),
    notifySummary: $('[data-v10-notify-summary]'),
    delivery: $('[data-pdp-delivery]'),
    ask: $('[data-v10-ask]'),
    msg: $('[data-v10-msg]'),
    gallery: $('[data-v10-gallery]'),
    thumbs: $$('[data-v10-thumb]'),
    count: $('[data-v10-count]'),
    alt: $('[data-pdp-alt]'),
    zoom: $('[data-pdp-zoom]'),
    dots: $$('[data-pdp-dots] span')
  };
  function notifyLabel(v) {
    return v.soon === 'Sold out' ? 'Email me when it\u2019s back' : 'Email me when it\u2019s in';
  }

  function text(node, value) {
    if (!node) return;
    node.textContent = value || '';
    node.hidden = !value;
  }

  /* El precio, con la misma forma que `snippets/unit.liquid`: entero con
     espacio fino de millares, céntimos solo si los hay, espacio duro y €. */
  function money(cents) {
    var n = Math.round(+cents || 0);
    var rest = n % 100;
    var int = String((n - rest) / 100).replace(/\B(?=(\d{3})+(?!\d))/g, '\u2009');
    return int + (rest ? '.' + String(rest).padStart(2, '0') : '') + '\u00a0\u20ac';
  }

  function subject(v) {
    return 'About ' + data.title + ' · ' + (v.sku || data.code || '');
  }

  function apply(v) {
    current = v;
    as.v10product.variantId = v.id;
    as.v10product.state = v.state;
    page.setAttribute('data-state', v.state);
    if (idInput) idInput.value = v.id;
    if (el.price && v.price > 0) el.price.textContent = money(v.price);

    var notify = v.state === 'notify';
    if (el.cta) { el.cta.hidden = notify; el.cta.textContent = notify ? '' : v.cta; }
    if (el.soon) { el.soon.hidden = !notify; el.soon.textContent = notify ? v.soon : ''; }
    if (el.notifySummary && notify) el.notifySummary.textContent = notifyLabel(v);
    if (el.propState) el.propState.disabled = v.state !== 'preorder';
    if (el.propWeeks) {
      el.propWeeks.disabled = v.state !== 'preorder';
      el.propWeeks.value = v.state === 'preorder' && v.weeks ? v.weeks + ' weeks' : '';
    }
    text(el.line, v.line);
    if (el.notify) {
      el.notify.hidden = !notify;
      var tags = el.notify.querySelector('[data-notify-tags]');
      if (tags) tags.value = tags.value.replace(/back:\d+/, 'back:' + v.id);
    }
    /* La entrega, solo en stock. */
    if (el.delivery) el.delivery.hidden = v.state !== 'in_stock';
    fields.forEach(function (f) { legend(f, v.options[+f.getAttribute('data-v10-opt')]); });
    marks(v.options);
    if (el.ask) el.ask.href = 'mailto:info@acaciasupplies.com?subject=' + encodeURIComponent(subject(v));
    if (el.msg) el.msg.textContent = '';

    try {
      var url = new URL(w.location.href);
      url.searchParams.set('variant', v.id);
      w.history.replaceState(w.history.state, '', url.toString());
    } catch (err) {
      console.warn('v10-product: could not update the URL', err);
    }

    /* El visor va a la foto de la variante, sin animar. */
    if (v.image && el.gallery) {
      var slide = el.gallery.querySelector('[data-image-id="' + v.image + '"]');
      if (slide) goTo(slide);
    }
  }

  fields.forEach(function (f) {
    var oi = +f.getAttribute('data-v10-opt');
    $$('[data-v10-opt-input]', f).forEach(function (input) {
      input.addEventListener('change', function () {
        var values = chosen();
        var v = exact(values) || bestFor(oi, input.value, values);
        if (!v) return;
        fields.forEach(function (g) {
          var gi = +g.getAttribute('data-v10-opt');
          $$('[data-v10-opt-input]', g).forEach(function (r) { r.checked = r.value === v.options[gi]; });
        });
        apply(v);
        if (oi === data.color) track('swatch_change', { variant_id: String(v.id), value: v.options[oi] });
      });
    });
    $$('[data-v10-swatch]', f).forEach(function (label) {
      label.addEventListener('mouseenter', function () { legend(f, label.getAttribute('data-name')); });
      label.addEventListener('mouseleave', function () { legend(f, current.options[oi]); });
    });
  });

  /* ── El visor y el carrusel ───────────────────────────────────────────── */
  var slides = el.gallery ? $$('[data-v10-slide]', el.gallery) : [];
  var viewSlides = slides.filter(function (s) { return s.hasAttribute('data-view'); });
  var viewAt = 0;
  /* Escritorio: la foto `i` del visor, en seco. */
  function show(i) {
    var s = viewSlides[i];
    if (!s) return;
    viewAt = i;
    viewSlides.forEach(function (x) { x.classList.toggle('is-on', x === s); });
    el.thumbs.forEach(function (t, k) {
      if (k === i) t.setAttribute('aria-current', 'true');
      else t.removeAttribute('aria-current');
    });
    if (desk.matches && el.count) el.count.textContent = pad(i + 1);
    if (el.alt) el.alt.textContent = s.getAttribute('data-alt') || '';
    if (el.zoom) {
      el.zoom.href = s.getAttribute('data-zoom') || el.zoom.href;
      el.zoom.setAttribute('aria-label', 'Photo ' + (i + 1) + ' at full size');
    }
  }
  /* Móvil: el contador y los puntos siguen al dedo. */
  function dot(k) {
    el.dots.forEach(function (s, j) { s.classList.toggle('is-on', j === k); });
    if (!desk.matches && el.count) el.count.textContent = pad(k + 1);
  }
  function goTo(slide) {
    if (desk.matches) {
      var vi = viewSlides.indexOf(slide);
      if (vi >= 0) show(vi);
    } else if (el.gallery) {
      el.gallery.scrollTo({ left: slide.offsetLeft - el.gallery.offsetLeft, behavior: 'instant' });
      dot(slides.indexOf(slide));
    }
  }
  if (el.gallery && 'IntersectionObserver' in w) {
    var gio = new IntersectionObserver(function (entries) {
      if (desk.matches) return;
      entries.forEach(function (en) {
        if (en.isIntersecting) dot(slides.indexOf(en.target));
      });
    }, { root: el.gallery, threshold: 0.6 });
    slides.forEach(function (s) { gio.observe(s); });
  }
  el.thumbs.forEach(function (t, i) {
    t.addEventListener('click', function () { show(i); });
    t.addEventListener('keydown', function (e) {
      var k = e.key;
      var n = el.thumbs.length;
      var step = k === 'ArrowDown' || k === 'ArrowRight' ? 1 : k === 'ArrowUp' || k === 'ArrowLeft' ? -1 : 0;
      var to = k === 'Home' ? 0 : k === 'End' ? n - 1 : step ? (i + step + n) % n : -1;
      if (to < 0) return;
      e.preventDefault();
      el.thumbs[to].focus();
      show(to);
    });
  });
  function onMode() {
    if (!el.count) return;
    if (desk.matches) el.count.textContent = pad(viewAt + 1);
    else {
      var k = el.dots.reduce(function (a, s, j) { return s.classList.contains('is-on') ? j : a; }, 0);
      el.count.textContent = pad(k + 1);
    }
  }

  /* ── El panel «Inside the piece» ──────────────────────────────────────── */
  var inside = $('[data-pdp-inside]');
  var viewer = $('[data-pdp-viewer]');
  var opener = $('[data-pdp-inside-open]');
  /* A9 (lote pdp-reassurance): sin JS la fila es un `<a href="#pdp-inside">`
     al panel pintado en la página; aquí pasa a ser el `<button>`. */
  if (opener && opener.tagName === 'A') {
    var ob = d.createElement('button');
    ob.type = 'button';
    Array.prototype.forEach.call(opener.attributes, function (at) {
      if (at.name !== 'href') ob.setAttribute(at.name, at.value);
    });
    ob.setAttribute('aria-expanded', 'false');
    while (opener.firstChild) ob.appendChild(opener.firstChild);
    opener.parentNode.replaceChild(ob, opener);
    opener = ob;
  }
  var closer = $('[data-pdp-inside-close]');
  var isOpen = false;
  function lock(on) {
    d.documentElement.classList.toggle('pdp-locked', !!on);
  }
  function layout() {
    if (!isOpen) { lock(false); if (viewer) viewer.hidden = false; return; }
    if (desk.matches) { lock(false); if (viewer) viewer.hidden = true; }
    else { lock(true); if (viewer) viewer.hidden = false; }
  }
  function openInside() {
    if (!inside || isOpen) return;
    isOpen = true;
    inside.hidden = false;
    if (opener) opener.setAttribute('aria-expanded', 'true');
    layout();
    if (as.pdpCol) as.pdpCol.mode();
    if (as.scale && as.scale.draw) as.scale.draw();
    if (desk.matches) {
      var top = inside.getBoundingClientRect().top;
      var head = parseFloat(getComputedStyle(d.documentElement).getPropertyValue('--header-h')) || 0;
      if (top < head) w.scrollTo({ top: w.scrollY + top - head - 48, behavior: 'instant' });
    }
    if (closer) closer.focus({ preventScroll: true });
    track('fits_view');
  }
  function closeInside() {
    if (!inside || !isOpen) return;
    isOpen = false;
    inside.hidden = true;
    if (opener) opener.setAttribute('aria-expanded', 'false');
    layout();
    if (as.pdpCol) as.pdpCol.mode();
    if (opener) opener.focus({ preventScroll: true });
  }
  if (opener) opener.addEventListener('click', function () { if (isOpen) closeInside(); else openInside(); });
  if (closer) closer.addEventListener('click', closeInside);
  d.addEventListener('keydown', function (e) {
    if (e.key === 'Escape' && isOpen) { e.preventDefault(); closeInside(); }
  });
  if (desk.addEventListener) desk.addEventListener('change', function () { layout(); onMode(); if (isOpen && as.scale) as.scale.draw(); });
  /* Un enlace de la página a algo del panel (la línea «Fits …» de 02
     Specifications apunta a `#what-fits`) abre el panel y va ahí. */
  d.addEventListener('click', function (e) {
    var a = e.target.closest && e.target.closest('a[href^="#"]');
    if (!a || !inside || inside.contains(a)) return;
    var id = a.getAttribute('href').slice(1);
    var to = id && d.getElementById(id);
    if (!to || !inside.contains(to)) return;
    e.preventDefault();
    openInside();
    to.scrollIntoView({ block: 'start', behavior: 'instant' });
  });
  as.inside = { open: openInside, close: closeInside, isOpen: function () { return isOpen; } };

  /* ── La columna: su modo sticky ───────────────────────────────────────── */
  var col = $('[data-pdp-col]');
  function headerH() {
    return parseFloat(getComputedStyle(d.documentElement).getPropertyValue('--header-h')) || 0;
  }
  function colMode() {
    if (!col) return;
    var room = d.documentElement.clientHeight - headerH();
    var tall = col.offsetHeight > room + 1;
    col.classList.toggle('is-tall', tall);
    col.classList.toggle('is-fit', !tall);
  }
  colMode();
  w.addEventListener('resize', colMode);
  if (col && 'ResizeObserver' in w) new ResizeObserver(colMode).observe(col);
  $$('details', col || page).forEach(function (x) { x.addEventListener('toggle', colMode); });
  as.pdpCol = { mode: colMode };

  /* ── What fits: un chip pulsado por pregunta ──────────────────────────── */
  $$('[data-pdp-fit-q]').forEach(function (q) {
    var chips = $$('[data-pdp-chip]', q);
    var out = q.querySelector('[data-pdp-fit-answer]');
    function pick(c) {
      chips.forEach(function (x) { x.setAttribute('aria-pressed', x === c ? 'true' : 'false'); });
      if (out) { out.textContent = c.getAttribute('data-text') || ''; out.setAttribute('data-ok', c.getAttribute('data-ok') || ''); }
    }
    var first = chips.filter(function (c) { return c.getAttribute('aria-pressed') === 'true'; })[0] || chips[0];
    if (first) pick(first);
    chips.forEach(function (c) { c.addEventListener('click', function () { pick(c); }); });
  });

  /* ── Añadir sin recargar ──────────────────────────────────────────────── */
  var via = 'product';
  function emit(name, detail) {
    d.dispatchEvent(new CustomEvent(name, { detail: detail }));
  }
  function focusNotify() {
    if (!el.notify) return;
    el.notify.open = true;
    var field = el.notify.querySelector('input[type="email"]');
    if (field) field.focus();
  }
  /* Las tarjetas enlazan a `#v10-notify`: el aviso llega abierto. */
  function openFromHash() {
    if (w.location.hash === '#v10-notify' && el.notify && !el.notify.hidden) el.notify.open = true;
  }
  openFromHash();
  w.addEventListener('hashchange', openFromHash);

  if (form) {
    form.addEventListener('submit', function (e) {
      if (!w.fetch || !w.FormData) return;
      e.preventDefault();
      var source = via;
      via = 'product';
      if (current.state === 'notify') { focusNotify(); return; }
      var btn = el.cta;
      if (btn && btn.getAttribute('aria-busy') === 'true') return;
      var state = current.state;
      var label = current.cta;
      var body = new FormData(form);
      var variantId = body.get('id');
      if (btn) btn.setAttribute('aria-busy', 'true');
      /* Una sola petición (lote home-pulido, S5): `site-drawer.js` manda el
         formulario a /cart/add.js con `sections=site-bag,header-bag-count`,
         sube «Bag (n)» antes de la respuesta y abre el drawer Bag de toda
         la web. La medición va por `v10:track` (`bag_add`). */
      if (el.msg) el.msg.textContent = '';
      (as.siteDrawer ? as.siteDrawer.add(body, { from: btn }) : Promise.reject(new Error('site-drawer.js is missing')))
        .then(function () {
          if (btn) {
            btn.textContent = 'Added';
            setTimeout(function () { if (current.cta === label && current.state !== 'notify') btn.textContent = label; }, 1600);
          }
          track('bag_add', { variant_id: String(variantId), state: state, source: source });
        })
        .catch(function (err) {
          console.error('v10-product: add failed', err);
          if (el.msg) el.msg.textContent = 'It couldn’t go in the bag. Try again.';
          emit('v10:cart-error', { error: String((err && err.message) || err), variantId: variantId });
        })
        .then(function () {
          if (btn) btn.removeAttribute('aria-busy');
        });
    });
  }

  /* ── Medición de cada zona ────────────────────────────────────────────── */
  if (el.ask) el.ask.addEventListener('click', function () { track('ask_click', { variant_id: String(current.id) }); });
  var specs = $('[data-pdp-row="specifications"]');
  if (specs) specs.addEventListener('toggle', function () { if (specs.open) track('specs_open'); });
  var box = el.notify && el.notify.querySelector('[data-capture]');
  if (box && 'MutationObserver' in w) {
    new MutationObserver(function () {
      if (box.hasAttribute('data-noted')) track('notify_join', { variant_id: String(current.id), state: 'notify' });
    }).observe(box, { attributes: true, attributeFilter: ['data-noted'] });
  }

  /* ── La entrega, en minutos ─────────────────────────────────────────────
     `scripts/lib/delivery-estimate.mjs`, la misma regla: hora de Barcelona,
     sale hoy si es laborable y antes del corte, entrega = salida + tránsito
     laborables, sin fines de semana ni festivos. Desde el lote
     pdp-reassurance (A3, 3 nov 2026) la frase dice los minutos que quedan
     («Order in the next 2 h 37 min · ships today · delivered Thu 6 Nov») o
     «Order now · ships tomorrow / ships Mon 9 Nov · …». El servidor la pinta
     con su hora; aquí se rehace al cargar, UNA VEZ POR MINUTO (nunca por
     segundo) y al volver de oculto. `as_country` (el drawer «Deliver to»)
     cambia la zona sin recargar. */
  var DAY = 86400000;
  var MINUTE = 60000;
  var WD = ['Sun', 'Mon', 'Tue', 'Wed', 'Thu', 'Fri', 'Sat'];
  var MO = ['Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun', 'Jul', 'Aug', 'Sep', 'Oct', 'Nov', 'Dec'];
  function toDay(iso) { return new Date(iso + 'T12:00:00Z'); }
  function fromDay(dt) { return dt.toISOString().slice(0, 10); }
  function addDays(iso, n) { return fromDay(new Date(toDay(iso).getTime() + n * DAY)); }
  function isBiz(iso, hol) { var wd = toDay(iso).getUTCDay(); return wd !== 0 && wd !== 6 && hol.indexOf(iso) < 0; }
  function nextBiz(iso, hol) { var x = addDays(iso, 1); while (!isBiz(x, hol)) x = addDays(x, 1); return x; }
  function addBiz(iso, n, hol) { var x = iso; for (var i = 0; i < n; i++) x = nextBiz(x, hol); return x; }
  function wall(now) {
    var p = {};
    new Intl.DateTimeFormat('en-GB', { timeZone: 'Europe/Madrid', year: 'numeric', month: '2-digit', day: '2-digit', hour: '2-digit', minute: '2-digit', hourCycle: 'h23' })
      .formatToParts(now).forEach(function (x) { p[x.type] = x.value; });
    return { date: p.year + '-' + p.month + '-' + p.day, minutes: +p.hour * 60 + +p.minute };
  }
  function estimate(now, cutoff, tmin, tmax, hol) {
    var m = /^([01]?\d|2[0-3]):([0-5]\d)$/.exec(cutoff);
    if (!m) return null;
    var cut = +m[1] * 60 + +m[2];
    var wl = wall(now);
    var today = isBiz(wl.date, hol) && wl.minutes < cut;
    var dispatch = today ? wl.date : nextBiz(wl.date, hol);
    return {
      today: wl.date,
      left: today ? cut - wl.minutes : null,
      dispatch: dispatch,
      min: addBiz(dispatch, tmin, hol),
      max: addBiz(dispatch, tmax, hol)
    };
  }
  function fmt(iso, month) { var x = toDay(iso); return WD[x.getUTCDay()] + ' ' + x.getUTCDate() + (month ? ' ' + MO[x.getUTCMonth()] : ''); }
  function range(e) {
    return e.min === e.max ? fmt(e.min, true) : fmt(e.min, e.min.slice(0, 7) !== e.max.slice(0, 7)) + ' – ' + fmt(e.max, true);
  }
  function lead(e) {
    if (e.left == null) return 'Order now';
    if (e.left >= 60) return 'Order in the next ' + Math.floor(e.left / 60) + ' h ' + (e.left % 60) + ' min';
    if (e.left >= 5) return 'Order in the next ' + e.left + ' min';
    return 'Order in the next few minutes';
  }
  function ships(e) {
    if (e.left != null) return 'ships today';
    if (e.dispatch === addDays(e.today, 1)) return 'ships tomorrow';
    return 'ships ' + fmt(e.dispatch, true);
  }
  function line(e) {
    return lead(e) + ' · ' + ships(e) + ' · delivered ' + range(e);
  }
  var dl = d.querySelector('[data-pdp-delivery]');
  var dlHol = dl ? (dl.getAttribute('data-holidays') || '').split(',').filter(Boolean) : [];
  var dlCut = dl ? dl.getAttribute('data-cutoff') : null;
  var dlZone = dl ? {
    iso: dl.getAttribute('data-country') || '',
    name: (dl.querySelector('[data-pdp-delivery-country]') || {}).textContent || '',
    tmin: +dl.getAttribute('data-transit-min'),
    tmax: +dl.getAttribute('data-transit-max'),
    rate: '',
    free: ''
  } : null;
  /* La zona elegida en «Deliver to», si la hay y el drawer la conoce. */
  if (dlZone && as.pdpDrawer) {
    var pageZone = as.pdpDrawer.zone(dlZone.iso);
    if (pageZone) { dlZone.rate = pageZone.rate; dlZone.free = pageZone.free; }
    var saved = as.pdpDrawer.country();
    var z = saved && saved !== dlZone.iso ? as.pdpDrawer.zone(saved) : null;
    if (z) dlZone = z;
  }
  function paintDelivery() {
    if (!dl || !dlZone) return;
    var out = dl.querySelector('[data-pdp-delivery-line]');
    var where = dl.querySelector('[data-pdp-delivery-country]');
    if (where && dlZone.name) where.textContent = dlZone.name;
    if (!out) return;
    var e = dlZone.tmin == null || dlZone.tmax == null || isNaN(dlZone.tmin) || isNaN(dlZone.tmax)
      ? null
      : estimate(new Date(), dlCut, Math.min(dlZone.tmin, dlZone.tmax), Math.max(dlZone.tmin, dlZone.tmax), dlHol);
    /* Sin zona con tránsito, sin frase (nunca un plazo por defecto). */
    out.textContent = e ? line(e) : '';
    if (e) {
      dl.setAttribute('data-dispatch', e.dispatch);
      dl.setAttribute('data-min', e.min);
      dl.setAttribute('data-max', e.max);
    }
    d.dispatchEvent(new CustomEvent('pdp:delivery'));
  }
  as.delivery = {
    estimate: estimate,
    line: line,
    range: range,
    cutoff: function () { return dlCut; },
    holidays: function () { return dlHol.slice(); }
  };
  as.deliveryZone = function () { return dlZone; };
  as.deliveryCountry = function () { return dlZone ? dlZone.iso : null; };
  if (dl) {
    paintDelivery();
    /* Una vez por minuto, alineado al cambio de minuto; nunca por segundo. */
    setTimeout(function () {
      paintDelivery();
      setInterval(paintDelivery, MINUTE);
    }, MINUTE - (Date.now() % MINUTE));
    d.addEventListener('visibilitychange', function () {
      if (d.visibilityState === 'visible') paintDelivery();
    });
    d.addEventListener('pdp:country', function (ev) {
      if (ev.detail) { dlZone = ev.detail; paintDelivery(); }
    });
  }

  track('product_view', { variant_id: String(current.id) });
})(window, document);
